/** @format */

import axios from 'axios'

import Notify from '../../../Notify'

import { ENV_COMMON, ENV_COUNTRY } from '../../Variables/Enviroment'

// export const AddressSetLocation = async (item, alias) => {
// 	let returnResponse
// 	let splitAddress
// 	await axios({
// 		method: 'GET',
// 		url: `${ENV_COMMON}/location/geocoding/${ENV_COUNTRY}`,
// 		params: {
// 			q: `${item}`,
// 		},
// 	})
// 		.then((response) => {
// 			if (response.data.statusCode === 200) {
// 				if (alias) {
// 					let newAdress
// 					newAdress = {
// 						location: {
// 							formatted_address: response.data.data[0].address_complete,
// 							formFields: item,
// 							geometry: {
// 								location: {
// 									lat: response.data.data[0].lat,
// 									lng: response.data.data[0].lng,
// 								},
// 							},
// 						},
// 					}
// 					returnResponse = newAdress
// 				} else {
// 					console.log('response.data.data[0].address_complete',response.data.data[0].address_complete)
// 					splitAddress = response.data.data[0].address_complete.split(',')
// 					let geometry = {
// 						lat: response.data.data[0].lat,
// 						lng: response.data.data[0].lng,
// 						address: response.data.data[0].address_complete,
// 						street: splitAddress[0],
// 						commune: splitAddress[1],
// 						region: splitAddress[2],
// 						formFields: item,
// 					}
// 					localStorage.setItem('locationStore', JSON.stringify(geometry))
// 					returnResponse = JSON.parse(localStorage.getItem('locationStore'))
// 				}
// 			} else {
// 				Notify({
// 					title: `Error ${response.data.statusCode}`,
// 					colorTitle: 'ph-main-notification-error-title',
// 					description: `${response.data.message}`,
// 					time: 3,
// 					image: 'error',
// 					placement: 'topRight',
// 				})
// 			}
// 		})
// 		.catch(() => {
// 			Notify({
// 				title: `Error`,
// 				colorTitle: 'ph-main-notification-error-title',
// 				description: 'Problemas con el servicio: Search Google Geocoding',
// 				time: 3,
// 				image: 'error',
// 				placement: 'topRight',
// 			})
// 		})
// 	return returnResponse
// }


export const AddressSetLocation = async (item, alias) => {
  let returnResponse

  await axios({
    method: 'GET',
    url: `${ENV_COMMON}/location/geocoding/${ENV_COUNTRY}`,
    params: {
      q: `${item}`,
    },
  })
    .then((response) => {
      if (response.data.statusCode === 200) {
        
        if (alias) {
          let newAdress
          newAdress = {
            location: {
              formatted_address: response.data.data[0].address_complete,
              formFields: item,
              geometry: {
                location: {
                  lat: response.data.data[0].lat,
                  lng: response.data.data[0].lng,
                },
              },
            },
          }
          returnResponse = newAdress
        
        } else {
          const fullAddress = response.data.data[0].address_complete;

          const parts = fullAddress.split(',').map(part => part.trim());
          const totalParts = parts.length;

          let street = '';
          let commune = '';
          let region = '';

          // Helper to clean street segment: remove trailing numbers, '#', 'no', 'piso', 'dpto', etc.
          const cleanStreetName = (s) => {
            if (!s) return '';
            let name = s.trim();
            // Remove common markers like '# 123', 'no 123', 'nº 123'
            name = name.replace(/\s*(?:#|n(?:o|º)\.?|No\.?|Nº\.?)\s*\S+$/i, '');
            // Remove trailing plain numbers e.g. ' 487' or ' 487A'
            name = name.replace(/\s+\d+[A-Za-z0-9-]*$/i, '');
            // Remove trailing descriptors like 'piso 2', 'dpto 3', 'apto 4', 'departamento X'
            name = name.replace(/\s*(?:piso|dpto|depto|apto|departamento|departamento:)\b.*$/i, '');
            return name.trim();
          };

          if (totalParts >= 3) {
            const lastPart = parts[totalParts - 1].toLowerCase();
            const hasCountry = lastPart.includes('chile');

            const regionIndex = hasCountry ? totalParts - 2 : totalParts - 1;
            const communeIndex = hasCountry ? totalParts - 3 : totalParts - 2;

            region = parts[regionIndex];
            commune = parts[communeIndex];

            // street keeps the full address with number (backward compatibility)
            street = parts.slice(0, communeIndex).join(', ');

          } else {
            street = parts[0];
            commune = parts[1] || '';
            region = parts[2] || '';
          }

          // streetName: clean version with only the street name (no number, piso, etc)
          const streetNameCleaned = cleanStreetName(parts[0] || '');

          let geometry = {
            lat: response.data.data[0].lat,
            lng: response.data.data[0].lng,
            address: fullAddress,
            street: street,
            streetName: streetNameCleaned,
            commune: commune,
            region: region,
            formFields: item,
          }

          localStorage.setItem('locationStore', JSON.stringify(geometry))
          returnResponse = JSON.parse(localStorage.getItem('locationStore'))
        }
      } else {
        Notify({
          title: `Error ${response.data.statusCode}`,
          colorTitle: 'ph-main-notification-error-title',
          description: `${response.data.message}`,
          time: 3,
          image: 'error',
          placement: 'topRight',
        })
      }
    })
    .catch(() => {
      Notify({
        title: `Error`,
        colorTitle: 'ph-main-notification-error-title',
        description: 'Problemas con el servicio: Search Google Geocoding',
        time: 3,
        image: 'error',
        placement: 'topRight',
      })
    })
  return returnResponse
}